import { render, staticRenderFns } from "./PetOwnerLogin.vue?vue&type=template&id=90fa50a2&scoped=true&"
import script from "./PetOwnerLogin.vue?vue&type=script&lang=js&"
export * from "./PetOwnerLogin.vue?vue&type=script&lang=js&"
import style0 from "./PetOwnerLogin.vue?vue&type=style&index=0&id=90fa50a2&prod&lang=scss&scoped=true&"
import style1 from "./PetOwnerLogin.vue?vue&type=style&index=1&id=90fa50a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fa50a2",
  null
  
)

export default component.exports